import * as blog from "./blog.module.scss";

import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React, {useEffect} from "react";

import { Link } from "gatsby";

export default function BlogListing({data, homeClass}) {
  useEffect(() => {
    // Lazy Load Images using Intersection Observer
    const observer = new IntersectionObserver(onIntersect);

    document.querySelectorAll("[data-lazy]").forEach(item => observer.observe(item));

    function onIntersect(entries) {
      entries.forEach((entry) => {
        if (entry.target.getAttribute("data-processed") || !entry.isIntersecting)
          return true;
        entry.target.setAttribute("src", entry.target.getAttribute("data-src"));
        entry.target.setAttribute("data-processed", true);
      });
    }
  },[]);

  return (
    <div
      className={
        homeClass
          ? `${blog.blogCard} cardsWrap ${blog.home_blog}`
          : `${blog.blogCard} cardsWrap`
      }
    >
      <div className={blog.featureImage}>
        <Link to={"/blog" + data.node.uri} className={blog.featureImageMain}>
          <GatsbyImage
            image={getImage(data?.node?.featuredImage?.node?.localFile)}
            alt={data?.node?.featuredImage?.node?.altText}
          />
        </Link>
        <div className={blog.authorImg}>
          <img
            src={data?.node?.author?.node?.avatar?.url.replace(
              "http://",
              "https://"
            )}
            alt={`${data?.node?.author?.node?.firstName} ${data?.node?.author?.node?.lastName}`}
          />
        </div>
      </div>
      <div className={blog.blogCont}>
        <div className={blog.blogHeader}>
          <div className={blog.authorName}>
            <span>
              {data.node.author.node.firstName}&nbsp;
              {data.node.author.node.lastName}
            </span>
            {data.node.blogSeo.readingTime && `- ${data.node.blogSeo.readingTime}`}
          </div>
          <div className={blog.dateMetaWrap}>
            <span>{data.node.date}</span>
          </div>
        </div>
        <h2>
          <Link to={"/blog" + data.node.uri}>{data.node.title}</Link>
        </h2>
      </div>
    </div>
  );
}
